// extracted by mini-css-extract-plugin
export default {"maxWidthModalDialog":"default-modal__max-width-modal-dialog__rZNi9","description":"default-modal__description__FHIt_","sectionHeader":"default-modal__section-header__seTyR"};